import { TERMINOS_PDF_PATH } from '@/lib/terminos';

export default function Footer() {
  return (
    <footer className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-t border-slate-200 dark:border-slate-800 mt-auto w-full">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2 opacity-50 grayscale">
          <span className="material-symbols-outlined">security</span>
          <span className="text-xs font-semibold uppercase tracking-widest text-slate-700 dark:text-slate-300">
            Plataforma Segura Certificada
          </span>
        </div>
        <p className="text-xs text-slate-400 font-medium">
          © {new Date().getFullYear()} FLUX Fintech Chile. Todos los derechos reservados.
        </p>
        <div className="flex gap-6">
          <a
            href={TERMINOS_PDF_PATH}
            target="_blank"
            className="text-xs text-slate-400 hover:text-primary transition-colors"
          >
            Términos y Condiciones
          </a>
          <a href="https://www.goflux.io" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-primary transition-colors">
            Ayuda
          </a>
        </div>
      </div>
    </footer>
  );
}
